import React, { useState, useEffect } from 'react';

const ADMIN_WA = '201008182425';
const F = "'Plus Jakarta Sans',sans-serif";

function getKey(email) { return `ic_first_login_${email}`; }

export default function WelcomeModal({ candidate, onClose }) {
  const [step, setStep] = useState(1);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!candidate?.email) return;
    const key = getKey(candidate.email);
    if (!localStorage.getItem(key)) {
      setVisible(true);
    }
  }, [candidate]);

  function close() {
    if (candidate?.email) localStorage.setItem(getKey(candidate.email), '1');
    setVisible(false);
    onClose && onClose();
  }

  if (!visible) return null;

  const steps = [
    {
      emoji: '🧭',
      title: 'Welcome to IELTSCOMPASS',
      subtitle: 'Here is what you can do on this platform:',
      content: (
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:10, marginBottom:20 }}>
          {[
            { icon:'✍️', t:'Smart Writing', s:'Guided essay practice, sentence by sentence', c:'#1a5fa8', bg:'#e8f0fb' },
            { icon:'⏱', t:'Test Mode',      s:'Full 40-minute exam simulation with timer',   c:'#b8620a', bg:'#fff8f0' },
            { icon:'📚', t:'Study Tools',    s:'Idea banks, sentence patterns, vocabulary',   c:'#1a7a4a', bg:'#e8f5ee' },
          ].map((item,i)=>(
            <div key={i} style={{ background:item.bg, border:`1px solid ${item.c}33`, borderRadius:12, padding:'14px 10px', textAlign:'center' }}>
              <div style={{ fontSize:26, marginBottom:6 }}>{item.icon}</div>
              <div style={{ fontSize:12.5, fontWeight:700, color:item.c, marginBottom:4 }}>{item.t}</div>
              <div style={{ fontSize:11, color:'#5a6a88', lineHeight:1.5 }}>{item.s}</div>
            </div>
          ))}
        </div>
      ),
    },
    {
      emoji: '📈',
      title: 'How to get the best results',
      subtitle: 'We recommend this study routine:',
      content: (
        <div style={{ marginBottom:20 }}>
          {[
            { n:'1', t:'Start with Smart Writing Mode', s:'Learn the essay structure paragraph by paragraph' },
            { n:'2', t:'Use the Ideas Bank first', s:'Gather strong arguments before you start writing' },
            { n:'3', t:'Practice in Sentences section', s:'Master the patterns used in Band 7+ essays' },
            { n:'4', t:'Take a Test Mode every week', s:'Track your progress under real exam conditions' },
          ].map((item,i)=>(
            <div key={i} style={{ display:'flex', gap:12, alignItems:'flex-start', marginBottom:12 }}>
              <div style={{ width:28, height:28, borderRadius:'50%', background:'#1a2a4a', color:'#d4a017', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:700, flexShrink:0, fontFamily:"'JetBrains Mono',monospace" }}>{item.n}</div>
              <div>
                <div style={{ fontSize:13.5, fontWeight:600, color:'#1a2233', marginBottom:2 }}>{item.t}</div>
                <div style={{ fontSize:12, color:'#5a6a88', lineHeight:1.55 }}>{item.s}</div>
              </div>
            </div>
          ))}
        </div>
      ),
    },
    {
      emoji: '🎯',
      title: "You're ready!",
      subtitle: 'Your free trial includes:',
      content: (
        <div style={{ marginBottom:20 }}>
          <div style={{ background:'#e8f5ee', border:'1px solid #c8ead8', borderRadius:10, padding:'14px 16px', marginBottom:16 }}>
            {['✍️ 1 Smart Writing practice with full AI feedback','⏱ 1 Test Mode exam simulation','💡 Unlimited access to Ideas, Sentences, and Vocabulary tools'].map((item,i)=>(
              <div key={i} style={{ fontSize:13, color:'#1a5a3a', lineHeight:1.85 }}>{item}</div>
            ))}
          </div>
          <div style={{ fontSize:13, color:'#5a6a88', marginBottom:12, textAlign:'center' }}>Want unlimited Smart Writing + Test Mode?</div>
          <a href={`https://wa.me/${ADMIN_WA}?text=${encodeURIComponent('Hello Mr. Ahmed Salem! I would like to upgrade my IELTS Compass access. Please help me.')}`}
            target="_blank" rel="noreferrer"
            style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:8, background:'#25d366', color:'#fff', textDecoration:'none', padding:'11px 20px', borderRadius:9, fontSize:13.5, fontWeight:700, fontFamily:F, marginBottom:4 }}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
            Upgrade My Access
          </a>
        </div>
      ),
    },
  ];

  const current = steps[step - 1];

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(26,42,74,0.6)', backdropFilter:'blur(3px)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:3000, padding:16 }}>
      <div className="fade-up" style={{ background:'#fff', borderRadius:20, padding:'32px 28px', maxWidth:480, width:'100%', boxShadow:'0 16px 60px rgba(26,42,74,0.25)', position:'relative' }}>
        {/* Step indicator */}
        <div style={{ display:'flex', justifyContent:'center', gap:6, marginBottom:20 }}>
          {steps.map((_,i)=>(
            <div key={i} style={{ width: step===i+1?24:8, height:8, borderRadius:100, background:step===i+1?'#b8860b':'#e8edf5', transition:'width .25s' }}/>
          ))}
        </div>

        <div style={{ textAlign:'center', fontSize:36, marginBottom:8 }}>{current.emoji}</div>
        <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:22, fontWeight:700, color:'#1a2a4a', textAlign:'center', marginBottom:4 }}>{current.title}</div>
        <div style={{ fontSize:13, color:'#5a6a88', textAlign:'center', marginBottom:20, lineHeight:1.6 }}>{current.subtitle}</div>

        {current.content}

        <button
          onClick={() => { if (step < 3) setStep(s => s + 1); else close(); }}
          style={{ width:'100%', background:step===3?'#1a2a4a':'linear-gradient(135deg,#b8860b,#d4a017)', color:'#fff', border:'none', padding:13, borderRadius:10, fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:F, boxShadow:step===3?'0 2px 10px rgba(26,42,74,0.25)':'0 2px 10px rgba(184,134,11,0.3)' }}>
          {step < 3 ? 'Next →' : 'Start Practising →'}
        </button>

        {/* Skip */}
        <div style={{ textAlign:'center', marginTop:10 }}>
          <button onClick={close} style={{ background:'none', border:'none', color:'#9aa3b8', fontSize:11.5, cursor:'pointer', fontFamily:"'JetBrains Mono',monospace" }}>
            Skip introduction
          </button>
        </div>
      </div>
    </div>
  );
}
